// extracted by mini-css-extract-plugin
export default {"link":"_M-z","disabled":"aN-z"};